import { render, staticRenderFns } from "./CreateFakeTeam.vue?vue&type=template&id=dd6a0c9e&scoped=true"
import script from "./CreateFakeTeam.vue?vue&type=script&lang=js"
export * from "./CreateFakeTeam.vue?vue&type=script&lang=js"
import style0 from "./CreateFakeTeam.vue?vue&type=style&index=0&id=dd6a0c9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a0c9e",
  null
  
)

export default component.exports